import React, { useContext } from 'react';

import { ArrowRightIcon } from '$partials/icon';
import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import { BookValuationModal } from '$partials/modals';
import { ModalContext } from '$contexts/modal.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').InListing}
 */
const InListing = ({
    text,
    ctaLabel,
    ctaLink,
    opensValuationModal,
    hubspot = {},
    ...rest
}) => {
    const link = formatLinkBlockToUrl(ctaLink);
    const { handleModal } = useContext(ModalContext);

    return (
        <div className='px5 md-px6 pt5 pb5 md-pb8 absolute bottom-0'>
            <div className='type-style-1 sans-serif sm-pr10 md-pr16'>
                <div className='pb3 md-pb6'>{text}</div>
                {opensValuationModal ? (
                    <Button
                        as = 'button'
                        className = 'bg-none type-style-5'
                        iconClassName='bg-sand black button border-radius-100px p3 md-p5'
                        look = 'underline'
                        onClick={() => { handleModal(
                            <BookValuationModal
                                context='Valuation Form'
                                hubspot={hubspot}
                                {...rest}/>); }}
                        renderIcon = {<ArrowRightIcon/>}>
                        {ctaLabel}
                    </Button>
                ) : (
                    <Button
                        as = 'a'
                        className = 'bg-none type-style-5 link-reset'
                        href={link}
                        iconClassName='bg-sand black button border-radius-100px p3 md-p5'
                        look = 'underline'
                        renderIcon={<ArrowRightIcon />}
                        target={ctaLink?.new_window || ctaLink?.linkTo === 'file' ? '_blank' : ''}>
                        {ctaLabel}
                    </Button>
                )}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default InListing;
